import reducer from "./reducer";
export { default as MedalTable } from "./components/index";
export { default as medalTableReducerName } from "./constants";
export default reducer;
